export enum LedgerType {
Main,
SubLedger,
}
